import { Status, useConductricsSelection } from '@dx-ui/framework-conductrics';
import type { AgentStatus } from '@dx-ui/framework-conductrics';

export function useJoinModalBenefitsSection(isModalOpen: boolean) {
  const status: AgentStatus = isModalOpen ? Status.OK : Status.PENDING;
  const { selection, isLoaded } = useConductricsSelection('a-auth-446', status);
  const shouldShowJoinModalBenefitsSection =
    isLoaded && selection?.choice?.toUpperCase() === 'B' && isModalOpen;

  return { isJoinModalBenefitsSectionLoaded: isLoaded, shouldShowJoinModalBenefitsSection };
}
